export default "__VITE_ASSET__BcVTIwbf__"